/* This method is also represented in @craft/lib, but @craft/lib cannot be a dependency to the
   @craft/logging package because the @craft/logging package needs to work on edge runtimes. */
export const isRecordType = (obj: unknown): obj is Record<string, unknown> =>
  typeof obj === 'object' && obj !== null && !Array.isArray(obj);
